import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import axios from 'axios'
import { ToastContainer } from 'react-toastify'

import App from './App'
import { store } from './store/store'
import setupAxios from './axios/setupAxios'
import reportWebVitals from './reportWebVitals'

import './index.scss'

setupAxios(axios)

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
    <ToastContainer />
  </React.StrictMode>
)

reportWebVitals()
